import { useSetAtom } from 'jotai'
import { useForm, useWatch } from 'react-hook-form'
import { useTranslation } from 'react-i18next'
import { yupFormResolver } from 'hooks/forms/yupFormResolver'
import { DEFAULT_FIAT_INSTRUMENT } from 'pages/Contacts/constants'
import { fiatSendFormAtom } from '../../Pay/atoms/atoms'
import { FiatSendFormData, fiatSendFormSchema } from '../form/fiatSendFormSchema'

export const useFiatSendForm = () => {
  const { t } = useTranslation()

  const setFiatSendFormAtom = useSetAtom(fiatSendFormAtom)

  const formSchema = fiatSendFormSchema(t)

  const form = useForm<FiatSendFormData>({
    defaultValues: DEFAULT_FIAT_INSTRUMENT,
    resolver: yupFormResolver<FiatSendFormData>(formSchema),
  })

  const {
    control,
    formState,
    handleSubmit,
    clearErrors,
    resetField,
    setValue,
    register,
    setError,
    trigger,
    watch,
  } = form

  const formValues = useWatch({ control }) as FiatSendFormData

  setFiatSendFormAtom({
    // form
    formValues,
    formState,
    errors: formState.errors,
    clearErrors,
    resetField,
    setValue,
    setError,
    register,
    trigger,
    watch,
    // form submit
    handleSubmit,
  })
}
